import { LatinAdverb } from "../LatinWord";

/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

export const LATIN_ADVERBS: Array<LatinAdverb> = [
  {
    type: "adverb",
    latin: "deinde",
    dutch: "daarna",
  }, {
    type: "adverb",
    latin: "dēnique",
    dutch: "ten slotte",
  }, {
    type: "adverb",
    latin: "domum",
    dutch: "naar huis",
  }, {
    type: "adverb",
    latin: "etiam",
    dutch: "ook; zelfs",
  }, {
    type: "adverb",
    latin: "hīc",
    dutch: "hier",
  }, {
    type: "adverb",
    latin: "iam",
    dutch: "al; dadelijk",
  }, {
    type: "adverb",
    latin: "ibi",
    dutch: "daar",
  }, {
    type: "adverb",
    latin: "ideō",
    dutch: "daarom",
  }, {
    type: "adverb",
    latin: "saepe",
    dutch: "dikwijls",
  }, {
    type: "adverb",
    latin: "semper",
    dutch: "altijd",
  }, {
    type: "adverb",
    latin: "sīc",
    dutch: "zo",
  }, {
    type: "adverb",
    latin: "simul",
    dutch: "tegelijk",
  }, {
    type: "adverb",
    latin: "statim",
    dutch: "dadelijk",
  }, {
    type: "adverb",
    latin: "tamen",
    dutch: "toch",
  }, {
    type: "adverb",
    latin: "tandem",
    dutch: "(uit)eindelijk",
  }, {
    type: "adverb",
    latin: "tum of tunc",
    dutch: "op dat moment",
  }, {
    type: "adverb",
    latin: "ubi?",
    dutch: "waar?; (daar) waar",
  }, {
    type: "adverb",
    latin: "maximē",
    dutch: "zeer; het meest",
  }, {
    type: "adverb",
    latin: "subitō",
    dutch: "plotseling",
  }, {
    type: "adverb",
    latin: "itaque",
    dutch: "daarom; en zo",
  },
  {
    type: "adverb",
    latin: "prīmum of prīmō",
    dutch: "eerst; voor het eerst",
  },
  {
    type: "adverb",
    latin: "quidem",
    dutch: "wel(iswaar); tenminste; meer bepaald",
  },
  {
    type: "adverb",
    latin: "quam",
    dutch: "dan; zo ... mogelijk",
  },
  {
    type: "adverb",
    latin: "tam",
    dutch: "zo; zozeer",
  },
  {
    type: "adverb",
    latin: "numquam",
    dutch: "nooit",
  },
  {
    type: "adverb",
    latin: "procul",
    dutch: "ver; van ver",
  },
  {
    type: "adverb",
    latin: "haud",
    dutch: "helemaal niet",
  },
  {
    type: "adverb",
    latin: "ūnā",
    dutch: "samen",
  },
  {
    type: "adverb",
    latin: "undique",
    dutch: "van overal; aan alle kanten",
  },
  {
    type: "adverb",
    latin: "fortasse",
    dutch: "misschien",
  },
  {
    type: "adverb",
    latin: "forte",
    dutch: "toevallig",
  },
  {
    type: "adverb",
    latin: "frūstrā",
    dutch: "tevergeefs",
  },
  {
    type: "adverb",
    latin: "multum (multō)",
    dutch: "veel",
  },
  {
    type: "adverb",
    latin: "bene",
    dutch: "goed",
  },
  {
    type: "adverb",
    latin: "immō",
    dutch: "integendeel; sterker nog",
  },
  {
    type: "adverb",
    latin: "prope",
    dutch: "dichtbij",
  },
  {
    type: "adverb",
    latin: "hinc",
    dutch: "van hier",
  },
  {
    type: "adverb",
    latin: "vix",
    dutch: "nauwelijks",
  },
  {
    type: "adverb",
    latin: "hūc",
    dutch: "hierheen",
  },
  {
    type: "adverb",
    latin: "nōn iam",
    dutch: "niet meer",
  },
  {
    type: "adverb",
    latin: "tantum",
    dutch: "zoveel; alleen maar",
  },
  {
    type: "adverb",
    latin: "paulō of paulum",
    dutch: "een beetje",
  },
  {
    type: "adverb",
    latin: "quoque",
    dutch: "ook",
  },
  {
    type: "adverb",
    latin: "adhūc",
    dutch: "tot nu toe; nog altijd",
  },
  {
    type: "adverb",
    latin: "diū",
    dutch: "lange tijd",
  },
  {
    type: "adverb",
    latin: "citō",
    dutch: "snel",
  },
  {
    type: "adverb",
    latin: "quō?",
    dutch: "waarheen?",
  },
  {
    type: "adverb",
    latin: "cottīdiē",
    dutch: "dagelijks",
  },
  {
    type: "adverb",
    latin: "crās",
    dutch: "morgen",
  },
  {
    type: "adverb",
    latin: "herī",
    dutch: "gisteren",
  },
  {
    type: "adverb",
    latin: "hodiē",
    dutch: "vandaag",
  },
  {
    type: "adverb",
    latin: "interdum",
    dutch: "soms",
  },
  {
    type: "adverb",
    latin: "intereā",
    dutch: "intussen",
  },
  {
    type: "adverb",
    latin: "interim",
    dutch: "intussen",
  },
  {
    type: "adverb",
    latin: "māne",
    dutch: "'s morgens",
  },
  {
    type: "adverb",
    latin: "mox",
    dutch: "weldra",
  },
  {
    type: "adverb",
    latin: "nunc",
    dutch: "nu",
  },
  {
    type: "adverb",
    latin: "ōlim",
    dutch: "eens",
  },
  {
    type: "adverb",
    latin: "ante(ā)",
    dutch: "vroeger",
  },
  {
    type: "adverb",
    latin: "post(eā)",
    dutch: "later",
  },
  {
    type: "adverb",
    latin: "posterō diē",
    dutch: "de volgende dag",
  },
  {
    type: "adverb",
    latin: "quōdam diē",
    dutch: "op een dag",
  },
  {
    type: "adverb",
    latin: "rūrsus",
    dutch: "opnieuw",
  },
  {
    type: "adverb",
    latin: "quandō?",
    dutch: "wanneer?",
  },
  {
    type: "adverb",
    latin: "inde",
    dutch: "vandaar; daarna; daarom",
  },
  {
    type: "adverb",
    latin: "plērumque",
    dutch: "meestal",
  },
  {
    type: "adverb",
    latin: "praetereā",
    dutch: "bovendien",
  },
  {
    type: "adverb",
    latin: "contrā",
    dutch: "ertegenover; anderzijds",
  },
  {
    type: "adverb",
    latin: "modo",
    dutch: "slechts; zojuist",
  },
  {
    type: "adverb",
    latin: "necesse",
    dutch: "nodig",
  },
  {
    type: "adverb",
    latin: "paene",
    dutch: "bijna",
  },
  {
    type: "adverb",
    latin: "domī",
    dutch: "thuis",
  },
  {
    type: "adverb",
    latin: "nōndum",
    dutch: "nog niet",
  },
  {
    type: "adverb",
    latin: "cūr?",
    dutch: "waarom?",
  },
  {
    type: "adverb",
    latin: "ferē",
    dutch: "bijna; meestal",
  },
  {
    type: "adverb",
    latin: "vērō",
    dutch: "inderdaad; maar",
  },
  {
    type: "adverb",
    latin: "longē",
    dutch: "ver; veruit",
  },
  {
    type: "adverb",
    latin: "magis",
    dutch: "meer",
  },
  {
    type: "adverb",
    latin: "iterum",
    dutch: "opnieuw",
  },
  {
    type: "adverb",
    latin: "ita",
    dutch: "zo",
  },
  {
    type: "adverb",
    latin: "quondam",
    dutch: "ooit",
  },
  {
    type: "adverb",
    latin: "parum",
    dutch: "onvoldoende",
  },
  {
    type: "adverb",
    latin: "satis",
    dutch: "genoeg; nogal",
  },
  {
    type: "adverb",
    latin: "omnīnō",
    dutch: "helemaal",
  },
  {
    type: "adverb",
    latin: "plūs",
    dutch: "meer",
  },
  {
    type: "adverb",
    latin: "plūrimum",
    dutch: "zeer veel",
  },
  {
    type: "adverb",
    latin: "quid?",
    dutch: "waarom?",
  },
  {
    type: "adverb",
    latin: "vērum of vērō",
    dutch: "inderdaad; maar",
  },
  // {
  //   type: "adverb",
  //   latin: "",
  //   dutch: "",
  // },
];

export function searchLatinAdverb(latin: string): LatinAdverb {
  const results = LATIN_ADVERBS.filter((adverb) => adverb.latin === latin);
  if (results.length !== 1) {
    console.error(results);
    throw new Error(`No single Latin adverb found for: "${latin}"`);
  }
  return results[0];
}